
export function PlaceholderImage({ className, style }) {
  return (
    <div className={className} style={{ ...style, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e5e7eb' }}>
      <i className="fas fa-image" style={{ fontSize: '64px', color: '#9ca3af' }}></i>
    </div>
  );
}

export function Badge({ children }) {
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: '0.5rem 0.75rem',
      borderRadius: '0.75rem',
      fontSize: '0.75rem',
      fontWeight: 600,
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      {children}
    </span>
  );
}